import angular from 'angular';

class envelopeContentCtrl {
  /* @ngInject */
  constructor($sce, Files) {
    this.$sce = $sce;
    this.Files = Files;
  }

  download(fileId) {
    return this.Files.download(fileId);
  }

  close() {
    this.modalInstance.dismiss();
  }
}

angular.module('dashboard').component('envelopeContent', {
  templateUrl: require('./envelope-content-popup.html'),
  controller: envelopeContentCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
